/**
 * THE MIDDLE NAME, as validate.js checks it — OPTIONAL (organiser, 22 Oct
 * 2026: a foreign athlete has none); typed, 3–50 characters. The server's
 * rule is the same (Profile::$middleName). Shared by every form that edits
 * it, so they cannot disagree.
 */
export const middleNameRule = value => (value ? { length: { minimum: 3, maximum: 50 } } : {});
